import { useReactiveVar } from "@apollo/client";
import { themeModeVariable } from "../setInitialData";

export const useThemeModeVariable = () => useReactiveVar(themeModeVariable);
